import React, { useState } from 'react';

import { Box, Container, Grid, Tab, Tabs, Typography } from '@material-ui/core';

import { Image } from '../components';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockFeatures } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
}));

type Props = BlockBuilder<BlockFeatures>;

export const FeaturesBlock: React.FC<Props> = ({ block, getImageData }) => {
  const classes = useBlockStyles(useStyles, block);
  const { title, items, tabs, align = 'left' } = block;
  const [activeTab, setActiveTab] = useState(tabs?.length ? tabs[0].id : '');
  const oddDirection = align === 'left' ? 'row-reverse' : 'row';
  const evenDirection = align === 'left' ? 'row' : 'row-reverse';
  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid container justifyContent="center" spacing={4}>
          {!!title && (
            <Grid item xs={10} style={{ textAlign: 'center' }}>
              <Typography variant="h3">{title}</Typography>
            </Grid>
          )}
          {!!tabs?.length && (
            <Grid item xs={10} style={{ textAlign: 'center' }}>
              <Grid container justifyContent="center">
                <Grid item xs={12} sm={6} md={4}>
                  <Tabs
                    variant="fullWidth"
                    value={activeTab}
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="how-it-works domestic international"
                    onChange={(_, newValue) => {
                      setActiveTab(newValue);
                    }}
                  >
                    {tabs.map(({ id, label }) => (
                      <Tab key={id} value={id} label={label} />
                    ))}
                  </Tabs>
                </Grid>
              </Grid>
            </Grid>
          )}
          {items
            .filter((item) => (!tabs?.length ? true : item.tabId === activeTab))
            .map((item, idx) => (
              <Grid
                container
                item
                alignItems="center"
                xs={10}
                key={idx}
                direction={idx % 2 ? oddDirection : evenDirection}
                spacing={4}
              >
                <Grid item md={8}>
                  <Typography variant="h4">{item.title}</Typography>
                  <br />
                  <Box
                    style={{ fontSize: '1rem' }}
                    dangerouslySetInnerHTML={{ __html: item.content }}
                  />
                </Grid>
                <Grid item md={4}>
                  <Image
                    getImageData={getImageData}
                    src={item.image}
                    alt={item.title}
                    options={{
                      width: '100%',
                      height: 'auto',
                    }}
                  />
                </Grid>
              </Grid>
            ))}
        </Grid>
      </Container>
    </Box>
  );
};
